import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { SellerDetails, SellerDetailsVariables } from "./types/SellerDetails";
import { SellerList, SellerListVariables } from "./types/SellerList";

const getSellerList = gql`
  query SellerList(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $status: SmopStatusEnum
    $filter: BrandInput
  ) {
    brandsPrivate(
      first: $first
      last: $last
      before: $before
      after: $after
      status: $status
      filter: $filter
    ) {
      edges {
        node {
          id
          name
          code
          legalName
          signatoryName
          signatoryEmail
          signatoryMobileNo
          mobileNo
          status
          sellerId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const useSellerListQuery = makeQuery<SellerList, SellerListVariables>(
  getSellerList
);

export const sellerDetailsQuery = gql`
  query SellerDetails($id: ID!) {
    brandPrivate(id: $id) {
      id
      name
      legalName
      code
      accountManager {
        id
        dateJoined
        firstName
        lastName
      }
      cluster {
        id
        name
      }
      completeAddress
      deeplinkUrl
      shortDynamicLink
      shopifyApiKey
      shopifyApiSecret
      shopifyApiShop
      shopifyExclusionTags {
        tag
      }
      shopifyNonCodTags {
        tag
      }
      storeType
      vendorId
      mobileNo
      status
      tinNo
      signatoryName
      signatoryEmail
      signatoryDesignation
      signatoryMobileNo
      bankName
      bankAccountName
      bankAccountNo
      financeName
      financeEmail
      financeMobileNo
      storeType
      tenants {
        id
        storeName
        legalName
        dateCreated
      }
      customerCode
      vendorCode
      isLargeTaxpayer
      isPayoutEligible
      swornDeclarationsFlag
      logo {
        url
        alt
      }
      vertical
    }
  }
`;
export const useSellerDetailsQuery = makeQuery<
  SellerDetails,
  SellerDetailsVariables
>(sellerDetailsQuery);
